<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs :tab-position="'top'">
                    <el-tab-pane :label="$t('getapi[945]')" name="0">
                        <el-table
                                id="xpane-0"
                                :data="dataSet"
                                ref="singleTable"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_Num" :label="$t('getapi[871]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_Type" :label="$t('getapi[6354]')">
                                <template scope="scope">
                                    {{scope.row.Doc_Type == 0?$t('getapi[878]'):$t('getapi[879]')}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Status" :label="$t('getapi[552]')">
                                <template scope="scope">
                                    {{expStatus(scope.row.Status)}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[3099]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[135]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Time" :label="$t('getapi[1210]')"></el-table-column>
                            <!--<el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[6355]')"></el-table-column>-->
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6362]')" name="1">
                        <el-table id="xpane-1" :data="personData" :height="tableHeight - reduceTableHeight" size="mini" border
                                  style="width: 100%;"
                                  @row-click="editInfo"
                                  :highlight-current-row="true"
                                  header-row-class-name="headerclass"
                                  ref="singleTable">
                            <el-table-column show-overflow-tooltip prop="Doc_Num" :label="$t('getapi[871]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_Type" :label="$t('getapi[6354]')">
                                <template scope="scope">
                                    {{scope.row.Doc_Type == 0?$t('getapi[878]'):$t('getapi[879]')}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Status" :label="$t('getapi[552]')">
                                <template scope="scope">
                                    {{expStatus(scope.row.Status)}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[3099]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[135]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Time" :label="$t('getapi[1210]')"></el-table-column>
                            <!--<el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[6355]')"></el-table-column>-->
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="display: flex;">
                    <el-button type="primary" size="mini" @click.native="setStatus(1)" :disabled="!btn.submit">{{$t('getapi[6468]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="setStatus(4)" :disabled="!btn.close">{{$t('getapi[6469]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="downloadModel">{{$t('getapi[6111]')}}</el-button>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :disabled="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3"
                            style="margin-left: 8px"
                    >
                        <el-button slot="trigger" size="mini" type="primary" :disabled="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3">{{$t('getapi[436]')}}</el-button>
                    </el-upload>
                    <el-button type="primary" size="mini" @click.native="setStatus(5)" style="margin-left: 8px">{{$t('getapi[2345]')}}</el-button>
                </div>
                <div style="width:600px;">
                    <table>
                        <tr>
                            <td style="width:80px;min-width:80px">{{$t('getapi[871]')}}</td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="dataDetail.Master.Doc_Num" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px">{{$t('getapi[552]')}}</td>
                            <td style="width:120px;min-width:120px">
                                <el-input :value="expStatus(dataDetail.Master.Status)" type="text" size="mini"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px">{{$t('getapi[6354]')}}</td>
                            <td style="width:120px;min-width:120px">
                                <el-select v-model="dataDetail.Master.Doc_Type" size="mini" :disabled="dataDetail.Sal_Price_Audit_LineList.length!=0">
                                    <el-option :label="$t('getapi[878]')" :value=0></el-option>
                                    <el-option :label="$t('getapi[879]')" :value=1></el-option>
                                </el-select>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[3099]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Create_Person" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[135]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Master.Create_Time" type="datetime" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{$t('getapi[733]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Modify_Person" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[1210]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Master.Modify_Time" type="datetime" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <!--<td>{{$t('getapi[6355]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Audit_Person" type="text" size="mini" :disabled="true"></el-input>
                            </td>-->
                        </tr>
                    </table>
                </div>
                <div style="margin-top: 10px">
                    <el-divider content-position="left">{{$t('getapi[941]')}}</el-divider>
                </div>
                <div class="btnnowrap">
                    <el-button type="primary" size="mini" @click="selectemployee(2)" :disabled="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3">{{$t('getapi[878]')}}</el-button>
                    <el-button type="primary" size="mini" @click="delemployee" :disabled="(dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3) || selectDataAudit.length < 1">{{$t('getapi[3889]')}}</el-button>
                </div>
                <el-table :data="dataDetail.DTAuditInfo" :height="120" size="mini" border
                          style="width: 100%;"
                          :row-class-name="tableRowClassNameAudit"
                          @selection-change="handleSelectionChangeAudit"
                          header-row-class-name="headerclass">
                    <!--<el-table-column show-overflow-tooltip prop="Sort" label="审核人顺序"></el-table-column>-->
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="Audit_Person" :label="$t('getapi[4043]')">
                        <template slot-scope="scope">
                            <el-input
                                    v-model="scope.row.Audit_Person"
                                    type="text"
                                    class="mcolor"
                                    size="mini"
                                    readonly
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(1,scope)"></i>
                            </el-input>
                        </template>
                    </el-table-column>
                    <!--<el-table-column show-overflow-tooltip prop="userID" label="审核人ID"></el-table-column>-->
                    <el-table-column prop="Audit_Status" :label="$t('getapi[6470]')">
                        <template slot-scope="scope">
                            {{expAuditStatus(scope.row.Audit_Status)}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[742]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Msg" :label="$t('getapi[6471]')"></el-table-column>
                    <el-table-column fixed="right" :label="$t('getapi[6048]')" width="100">
                        <template slot-scope="scope">
                            <el-button style="padding:0px"  v-if="dataDetail.Master.Status==1&&(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2)&& (user == scope.row.Audit_Person || scope.row.superior_flag==1) && scope.row.Exclusively_ID == currentAuditId" @click.native.prevent="Audit(scope,1)" type="text" size="mini">{{$t('getapi[941]')}}</el-button>
                            <el-button style="padding:0px"  v-if="dataDetail.Master.Status==1&&(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2)&& (user == scope.row.Audit_Person || scope.row.superior_flag==1) && scope.row.Exclusively_ID == currentAuditId" @click.native.prevent="Audit(scope,2)" type="text" size="mini">{{$t('getapi[6228]')}}</el-button>
                            <el-button v-if="addoredit != 1 && dataDetail.Master.Status==0 && dataDetail.Master.Unusual_Cost < 1000  && !btn.onlyone" @click.native.prevent="delAuditer(scope)" type="text" size="mini">{{$t('getapi[40]')}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top: 10px">
                    <el-divider content-position="left">{{$t('getapi[6440]')}}</el-divider>
                </div>
                <div class="inline-container">
                    <el-button size="mini" type="primary" @click="addline" :disabled="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3">{{$t('getapi[878]')}}</el-button>
                    <el-button size="mini" type="primary" @click="delline" :disabled="(dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3) || selectData.length < 1">{{$t('getapi[3889]')}}</el-button>
                    <div style="width: 10px;height: 10px;" class="red"></div><label>表示该行不含税价格与上一版本相差超过10%</label>  
                    <div style="width: 10px;height: 10px;" class="blue"></div><label>表示该行未匹配到上一版本不含税价格</label> 
                </div>
                <el-table id="xdetilpane-0" 
                        :data="dataDetail.Sal_Price_Audit_LineList" 
                        :height="tableHeight - 310" 
                        size="mini" border
                        style="width: 100%;
                        margin-top: 3px" 
                        header-row-class-name="headerclass"
                        :row-class-name="tableRowClassName"
                        @selection-change="handleSelectionChange">
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Err_Msg" :label="$t('getapi[4422]')" v-if="showError">
                    </el-table-column>
                    <el-table-column prop="Sales_Part" :label="$t('getapi[2652]')" width="120">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input
                                    v-model="scope.row.Sales_Part"
                                    type="text"
                                    class="mcolor"
                                    size="mini"
                                    readonly
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSalesPart(scope)"></i>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Part_Name" :label="$t('getapi[2653]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Part_Version" :label="$t('getapi[113]')"></el-table-column>
                    <el-table-column prop="Sales_Rate" :label="$t('getapi[12832]')" >
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.Sales_Rate" type="number" autocomplete="off" title="" v-if="userData.Login_DB == 'MLXY'" class="mcolor" @mousewheel.native.prevent  size="mini" ></el-input>
                            <el-input v-model="scope.row.Sales_Rate" type="number" autocomplete="off" title="" v-if="userData.Login_DB != 'MLXY'"  @mousewheel.native.prevent  size="mini" ></el-input>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="CusPart_ID" :label="$t('getapi[2390]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.CusPart_ID" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="CusPart_Name" :label="$t('getapi[2391]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.CusPart_Name" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Customer_ID" :label="$t('getapi[2610]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input
                                    v-model="scope.row.Customer_ID"
                                    type="text"
                                    @change="clearCustomer(scope)"
                                    size="mini"
                                    readonly
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectCusCode(scope)"></i>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Customer_Name" :label="$t('getapi[2584]')"></el-table-column>
                    <el-table-column prop="MOQ" label="MOQ">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.MOQ" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="Currency_Unit" :label="$t('getapi[1338]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-select filterable v-model="scope.row.Currency_Unit" size="mini" @change="changeCurrency(scope)" :disabled="scope.row.Customer_ID != ''">
                                <el-option v-for="(item, index) in Currency" :label="item.currency_code"
                                           :value="item.currency_code" :key="index" ></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sal_moq" :label="$t('getapi[12873]')" align="right">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.sal_moq" type="number" autocomplete="off" title="" ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Price" :label="$t('getapi[1292]')" align="right">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.Price" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" @change="getNetPrice(scope)" @focus="handleInputFocus(scope)"
                                      @blur="handleInputBlur(scope)"></el-input>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="Net_Price" :label="$t('getapi[1343]')" align="right">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.Net_Price" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" @change="getPrice(scope)" @focus="handleInputFocus(scope)"
                                      @blur="handleInputBlur(scope)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="base_price" :label="$t('getapi[13011]')" align="right" v-if="a125 == 1">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.base_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" @change="getBaseNetPrice(scope)" @focus="handleInputFocus(scope)"
                                      @blur="handleInputBlur(scope)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="base_net_price" :label="$t('getapi[13012]')" align="right" v-if="a125 == 1">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.base_net_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" @change="getBasePrice(scope)" @focus="handleInputFocus(scope)"
                                      @blur="handleInputBlur(scope)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Cust_Version" :label="$t('getapi[6352]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.Cust_Version" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Sales_Type" :label="$t('getapi[1113]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-select filterable v-model="scope.row.Sales_Type" size="mini">
                                <el-option v-for="item in arrSales_Type" :label="item.TypeName" :value="item.TypeName" :key="item.Exclusively_Id"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Package" :label="$t('getapi[3417]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-select filterable v-model="scope.row.Package" size="mini">
                                <el-option v-for="item in arrPackage" :label="item.TypeName" :value="item.TypeName" :key="item.Exclusively_Id"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Model" :label="$t('getapi[124]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.Model" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Spec" :label="$t('getapi[125]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.Spec" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Package_Size" :label="$t('getapi[6353]')" align="right">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.Package_Size" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Remark" :label="$t('getapi[143]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.Remark" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Tag_Single" :label="$t('getapi[6382]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.Tag_Single" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Tag_Packag" :label="$t('getapi[6383]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.Tag_Packag" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cus_chartnum" :label="$t('getapi[8960]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.cus_chartnum" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="processing" :label="$t('getapi[8955]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.processing" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="customsname" :label="$t('getapi[12969]')">
                        <template scope="scope" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                            <el-input v-model="scope.row.customsname" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')"></el-table-column>
                    <el-table-column width="20">
                    </el-table-column>
                </el-table>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="SalPriceAuditViewInfo" ref="ser" @getser="serclick"></serce>
        <el-dialog v-dialogDrag
                   :title="$t('getapi[6472]')"
                   :visible.sync="CloseDialogVisible"
                   width="30%"
        >
            <el-input
                    type="textarea"
                    :rows="5"
                    v-model="resontxt">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmAudit(selectrow,2)">{{$t('getapi[1146]')}}</el-button>
            </span>
        </el-dialog>

        <selector :isVisible="false" :isSplitPage=true :postUrl="'/Sal/Part/GetSalPartPopupList'" @callback="getSalesPart" ref="salespart"></selector>
        <selector :isVisible="false" :isSplitPage=true :postUrl="'/Basic/Popup/GetSalPartCodeDataList'" @callback="getSalesPart" ref="salespart_edit"></selector>
        <selector :isVisible="false" :selectType="0" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetSALCustomerDataList'" @callback="getCusCode" ref="cuscode"></selector>

        <selector :isVisible="false" :isBatch=true :isSplitPage=true :selectType="1"
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                  @callback="getemployee" ref="employee"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: 'salepriceaudit',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('salepriceaudit'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                code: '',
                dataDetail: {
                    Master: {},
                    DTAuditInfo: [],
                    Sal_Price_Audit_LineList: []
                },
                CloseDialogVisible: false,
                selectrow: {},
                resontxt: '',
                uploadurl: '',
                fileList: [],
                file: null,
                btn: {
                    submit: false,
                    close: false,
                },
                oldrow: '',
                iscontinuedblclick: true,
                selectData: [],
                selectDataAudit: [],
                currentAuditId: 0,
                addoredit: 1,
                selectIndex: -1,
                Currency: [], //货币代码
                arrSales_Type: [], //销售类别
                arrPackage:[], //包装方式
                showError: false,
                personData: [],
                saletype: 1, //1:新增2：修改
                employeeType: 1,//1:编辑审核人员2：新增审核人员
                selectIndexAudit: -1,
                timeId: null,
                scrollTop:0,
                scrollTop1:0,
                a125:0,// 判断是否显示基准含税价和基准不含税价
            };
        },
        beforeMount() {
            let that = this;
            that.fileList = [];
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            let token = that.userData.token;
            that.uploadurl = Common.Url + '/SalPriceAudit/GetTSPALModelData?token=' + token;
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
            personData: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(1)
                })
            },
            dataDetail: function () {
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.$processdata.pushModelCache('salepriceaudit', that)
            that.$http.urlpost('CurrencySource', {}, function (res) {
                if (res.Success == 1) {
                    that.Currency = res.DataContent;
                }
            });
            that.$http.urlpost('Basic/Sale/GetSalTypeList', {}, function(res) {
                if (res.Success == 1) {
                    that.arrSales_Type = res.DataContent;
                }
            });
            //包装方式
            that.$http.urlpost('Basic/Sale/GetPuckTypeList', {}, function(res) {
                if (res.Success == 1) {
                    that.arrPackage = res.DataContent;
                }
            });
            that.$http.urlpost('Basic/GetCurARate', {}, function (res) {
                if (res.Success == 1) {
                    that.a125 = res.DataContent[0].a125

                }
            });
            that.$limits.dragControllerDiv();
            that.confirmAdd();
            that.getView();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6554]"),this.$t("getapi[14]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (!that.$limits.fnIsEmpty(that.dataDetail.Master.Doc_Num)) {
                    if (that.dataDetail.Master.Status == 0 || that.dataDetail.Master.Status == 3) {
                        that.$refs.SetBtn.SetButtonEnable('create,search,save,del,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
                    }
                } else {
                    that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
                }
                that.btnauthority()
            },
            btnauthority() {
                let that = this;
                that.btn.submit = false
                that.btn.close = false
                if(!that.$limits.fnIsEmpty(that.dataDetail.Master.Doc_Num)){
                    if(that.dataDetail.Master.Status == 0 || that.dataDetail.Master.Status == 3){
                        that.btn.submit = true
                    }
                    if(that.dataDetail.Master.Status == 2){
                        if (that.$limits.authority('plv4', 519,1) > 0) {
                            that.btn.close = true
                        }
                    }
                    if(that.dataDetail.Master.Status == 4){
                        that.btn.submit = false
                    }
                } else {
                    that.btn.submit = false
                    that.btn.close = false
                }
                that.currentAuditId = 0
                let arrDTAuditInfo = []
                for(let i = 0;i<that.dataDetail.DTAuditInfo.length;i++){
                    arrDTAuditInfo.push(that.dataDetail.DTAuditInfo[i])
                }
                if(arrDTAuditInfo.length > 0){
                    let arr = arrDTAuditInfo.filter(row => row.Audit_Status == 0 || row.Audit_Status == 2)
                    let compare = function(obj1,obj2){
                        let val1 = obj1.Sort;
                        let val2 = obj2.Sort;
                        if(val1 < val2){
                            return -1;
                        }else if(val1 > val2){
                            return 1;
                        }else{
                            return 0;
                        }
                    }
                    let sortArr = arr.sort(compare);
                    if(sortArr.length > 0){
                        that.currentAuditId = sortArr[0].Exclusively_ID
                    }
                }
            },
            tableRowClassNameAudit({row, rowIndex}){
                row.index = rowIndex;
            },
            tableRowClassName({row, rowIndex}){
                row.index = rowIndex;
                if(row.price_diff==2){
                    return 'red'
                }
                else if(row.price_diff==1){
                    return 'blue'
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('salepriceaudit',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'SalPriceAuditViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/SalPriceAudit/GetSalPriceAuditView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                        that.getAuditPerson()
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.code == row.Exclusively_ID){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.DTAuditInfo.length;i++){
                        delete datacopy.DTAuditInfo[i]['index']
                    }
                    for(let i = 0;i<datacopy.Sal_Price_Audit_LineList.length;i++){
                        delete datacopy.Sal_Price_Audit_LineList[i]['index']
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.addoredit = 2;
                                that.code = row.Exclusively_ID
                                that.getDetail(that.code);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.addoredit = 2;
                        that.code = row.Exclusively_ID
                        that.getDetail(that.code);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(code) {
                let that = this;
                that.addoredit = 2
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/SalPriceAudit/SalPriceAuditInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.getNoTaxedCost()
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                    }
                    loadingInstance.close()
                });
            },
            getNoTaxedCost(){
                let that = this
                if(!that.$limits.fnIsEmpty(that.dataDetail.Master.Actual_Cost)){
                    that.dataDetail.Master.NoTaxed_Cost = that.$processdata.mathRound2(that.dataDetail.Master.Actual_Cost / 1.09)
                }
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DTAuditInfo.length;i++){
                    delete datacopy.DTAuditInfo[i]['index']
                }
                for(let i = 0;i<datacopy.Sal_Price_Audit_LineList.length;i++){
                    delete datacopy.Sal_Price_Audit_LineList[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                that.addoredit = 1;
                that.code = ''
                that.dataDetail = {
                    Master: {
                        Exclusively_ID: 0,
                        Doc_Num: '',
                        Doc_Type: 0,
                        Status: 0,
                        Create_Person: '',
                        Create_Time: '',
                        Modify_Person: '',
                        Modify_Time: '',
                        IsEdit: 1,
                        Audit_Person: ''
                    },
                    DTAuditInfo: [],
                    Sal_Price_Audit_LineList:[]
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DTAuditInfo.length;i++){
                    delete datacopy.DTAuditInfo[i]['index']
                }
                for(let i = 0;i<datacopy.Sal_Price_Audit_LineList.length;i++){
                    delete datacopy.Sal_Price_Audit_LineList[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 2){
                                that.getView();
                                that.getDetail(that.code)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if(that.addoredit == 2){
                        that.getView();
                        that.getDetail(that.code)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[6554]')
                };
                that.$http.urlpost('/SalPriceAudit/GetSalPriceAuditViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 保存
            async save() {
                let that = this;
                await this.$nextTick();
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.dataDetail.Master.Modify_Person = that.user
                let parm = that.dataDetail;
                //新增时校验槟城销售件占比是否为空
                if(that.userData.Login_DB == 'MLXY'){
                    for(let i=0;i<that.dataDetail.Sal_Price_Audit_LineList.length;i++){
                        if (that.fnIsEmpty(that.dataDetail.Sal_Price_Audit_LineList[i].Sales_Rate)) {
                            that.$refs.SetBtn.SetOneBtnEnable('save', true);
                            that.$message.warning(that.$t('getapi[12835]'));//'销售件占比值必须在0与1之间'
                            return;
                        }
                        else{
                            if(that.$processdata.mathRound2(that.dataDetail.Sal_Price_Audit_LineList[i].Sales_Rate)>1 || that.$processdata.mathRound2(that.dataDetail.Sal_Price_Audit_LineList[i].Sales_Rate)<0){
                                that.$refs.SetBtn.SetOneBtnEnable('save', true);
                                that.$message.warning(that.$t('getapi[12835]'));//'销售件占比值必须在0与1之间'
                                return;
                            }
                        }
                    }
                }

                that.$http.urlpost('/SalPriceAudit/SaveSalPriceAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.code = res.UniqueNum
                        that.getView()
                        that.getDetail(res.UniqueNum)
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                });

            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            ids: that.dataDetail.Master.Exclusively_ID
                        }
                        that.$http.urlpost('/SalPriceAudit/DelSalPriceAuditByID', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 1提交4关闭
            setStatus(val){
                let that = this;
                let parm = {
                    "Exclusively_ID": that.dataDetail.Master.Exclusively_ID,
                    "Doc_Num": that.dataDetail.Master.Doc_Num,
                    "Doc_Type": that.dataDetail.Master.Doc_Type,
                    "Status": val,
                    "Create_Person": that.dataDetail.Master.Create_Person,
                    "Create_Time": that.dataDetail.Master.Create_Time,
                    "Modify_Person": that.dataDetail.Master.Modify_Person,
                    "Modify_Time": that.dataDetail.Master.Modify_Time,
                    "IsEdit": that.dataDetail.Master.IsEdit,
                    "Audit_Person": that.dataDetail.Master.Audit_Person,
                    LangType: that.$processdata.getLang()
                }
                parm.Status = val
                that.btn.submit = false
                that.$http.urlpost('/SalPriceAudit/SalPriceAuditSetStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                        that.showError = false
                    } else {
                        that.showError = true
                        that.dataDetail.Sal_Price_Audit_LineList = res.DataContent
                        that.btn.submit = true
                    }
                });
            },
            // 审核 驳回
            Audit(scope,flag){
                let that =this;
                if(flag == 1){
                    this.$confirm(that.$t('getapi[8606]'), that.$t('getapi[194]'), {//'确认审核通过吗'
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.confirmAudit(scope.row,1)
                        })
                        .catch(() => {
                        });
                } else if(flag==2){
                    that.CloseDialogVisible = true;
                    that.selectrow = scope.row;
                    that.resontxt = '';
                }
            },
            confirmAudit(row,type){
                let that = this
                row.Audit_Date = that.$limits.getDateTime()
                if(type == 1){
                    row.Audit_Msg = ''
                } else {
                    row.Audit_Msg = that.resontxt
                }
                row.Audit_Status = type
                let parm = row
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/SalPriceAudit/SalPriceAuditInfoSetStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.getView();
                        that.getDetail(that.code);
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.CloseDialogVisible = false
                    } else {
                        that.getDetail(that.code);
                    }
                });
            },
            expStatus(val){
                if(val == 0){
                    return this.$t('getapi[1422]')//生成
                } else if(val == 1){
                    return this.$t('getapi[8057]')//审核中
                } else if(val == 2){
                    return this.$t('getapi[5160]')//批准'
                } else if(val == 3){
                    return this.$t('getapi[5161]')//'驳回'
                } else if(val == 4){
                    return this.$t('getapi[6469]')//'发布'
                } else if(val == 5){
                    return this.$t('getapi[441]')//'关闭'
                } else {
                    return ''
                }
            },
            expAuditStatus(val){
                let that = this
                if(val == 0){
                    return this.$t('getapi[2662]')//'未审'
                } else if(val == 1){
                    return this.$t('getapi[2663]')//'已审'
                } else if(val == 2){
                    return this.$t('getapi[5161]')//'驳回'
                } else {
                    return ''
                }
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
            },
            handleSelectionChangeAudit(val) {
                let that = this;
                that.selectDataAudit = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectDataAudit.push(val[i]);
                }
            },
            addline(){
                let that = this
                that.dataDetail.Sal_Price_Audit_LineList = [...that.dataDetail.Sal_Price_Audit_LineList,{
                    Exclusively_ID: 0,
                    Relation_IID: that.dataDetail.Master.Exclusively_ID,
                    Sales_Part: '',
                    Part_Name: '',
                    Part_Version: '',
                    CusPart_ID: '',
                    CusPart_Name: '',
                    Customer_ID: '',
                    MOQ: '',
                    sal_moq:0,
                    Price: '',
                    Net_Price: '',
                    Cust_Version: '',
                    Sales_Type: '',
                    Package: '',
                    Model: '',
                    Spec: '',
                    Currency_Unit: '',
                    Package_Size: '',
                    Remark: '',
                    Sales_Rate:0.00,
                    customsname:'',
                    base_price:'',
                    base_net_price:'',
                }]
            },
            // 删除询价表明细
            delline(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let ids = ''
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.dataDetail.Sal_Price_Audit_LineList.splice(that.selectData[i].index, 1);
                            if(that.selectData[i].Exclusively_ID!=0){
                                ids = ids + that.selectData[i].Exclusively_ID + ',';
                            }
                        }
                        if(ids != ''){
                            ids = ids.substring(0, ids.length -1)
                            let parm = {
                                ids: ids
                            }
                            that.$http.urlpost('/SalPriceAudit/DelSalPriceAuditLineByID', parm , function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 删除审核人
            delemployee(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let str = ''
                        for (let i = that.selectDataAudit.length - 1; i >= 0; i--) {
                            that.dataDetail.DTAuditInfo.splice(that.selectDataAudit[i].index, 1);
                            if(that.selectDataAudit[i].Exclusively_ID != ''){
                                str = str + that.selectDataAudit[i].Exclusively_ID + ','
                            }
                        }
                        if(str != ''){
                            str = str.substring(0,str.length-1)
                            let parm = {
                                ids: str
                            }
                            that.$http.urlpost('/SalPriceAudit/DelSalPriceAuditInfoByID', parm , function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //选择销售件编码
            selectSalesPart(row) {
                let that = this
                that.selectIndex = row.$index;
                if(that.dataDetail.Master.Doc_Type == 0){
                    that.saletype = 1
                    this.$refs.salespart.clearInput(true);
                } else {
                    that.saletype = 2
                    this.$refs.salespart_edit.clearInput(true);
                }
            },
            getSalesPart(val) {
                console.log(val);
                let that = this;
                if(that.saletype == 1){
                    that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].Sales_Part = val.part_code;
                    that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].Model = val.part_model
                    that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].Spec = val.part_spec
                } else{
                    that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].Sales_Part = val.sales_part;
                    that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].Model = val.model
                    that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].Spec = val.spec
                }
                that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].Part_Name = val.part_name;
                that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].Part_Version = val.part_version;
                that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].Cust_Version = val.part_version
                that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].Sales_Rate = val.sales_rate,
                that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].sal_moq = val.sal_moq,
                that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].customsname = val.customsname
                that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].item_code = val.item_code
                
            },
            //选择客户编码
            selectCusCode(row) {
                let that = this;
                that.selectIndex = row.$index;
                that.$refs.cuscode.clearInput(true);
            },
            getCusCode(val) {
                let that = this;
                console.log(val)
                that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].Customer_ID = val.customer_id;
                that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].Customer_Name = val.customer_name;
                that.dataDetail.Sal_Price_Audit_LineList[that.selectIndex].Currency_Unit = val.currency_code_id
            },
            clearCustomer(row){
                let that = this
                let index = row.$index
                console.log(that.dataDetail.Sal_Price_Audit_LineList[index].Customer_ID)
                if(that.dataDetail.Sal_Price_Audit_LineList[index].Customer_ID == ''){
                    that.dataDetail.Sal_Price_Audit_LineList[index].Customer_Name = ''
                }
            },
            downloadModel(){
                let that = this
                let param={
                    url:'/SalPriceAudit/GetTSPALModelImportTemplat'
                }
                Array.methods.DownLoadTemp(param);
            },
            handleChange(file, fileList) {
                let that = this;
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    let data = res.DataContent.Lists
                    for (let i = 0; i < data.length; i++) {
                        that.dataDetail.Sal_Price_Audit_LineList = [...that.dataDetail.Sal_Price_Audit_LineList,{
                            Exclusively_ID: 0,
                            Relation_IID: that.dataDetail.Master.Exclusively_ID,
                            Sales_Part: data[i].Sales_Part,
                            Part_Name: data[i].Part_Name,
                            Part_Version: data[i].Part_Version,
                            CusPart_ID: data[i].CusPart_ID,
                            CusPart_Name: data[i].CusPart_Name,
                            Customer_ID: data[i].Customer_ID,
                            MOQ: data[i].MOQ,
                            sal_moq: data[i].sal_moq,                            
                            Price: data[i].Price,
                            Net_Price: data[i].Net_Price,
                            Cust_Version: data[i].Cust_Version,
                            Sales_Type: data[i].Sales_Type,
                            Package: data[i].Package,
                            Model: data[i].Model,
                            Spec: data[i].Spec,
                            Currency_Unit: data[i].Currency_Unit,
                            Package_Size: data[i].Package_Size,
                            Remark: data[i].Remark,
                            Tag_Single: data[i].Tag_Single,
                            Tag_Packag: data[i].Tag_Packag,
                            Sales_Rate:data[i].Sales_Rate,
                            customsname:data[i].customsname,
                            base_price:data[i].base_price,
                            base_net_price:data[i].base_net_price,
                            item_code:data[i].item_code,
                        }]
                    }
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            getAuditPerson(){
                let that = this
                let parm = {
                    AuditPerson: that.user
                }
                that.$http.urlpost('/SalPriceAudit/SalPriceAuditListByAuditPerson', parm , function (res) {
                    if (res.Success == 1) {
                        that.personData = res.DataContent
                    }
                });
            },
            changeCurrency(row){
                let that = this
                row.row.Net_Price = ''
                row.row.Price = ''
            },
            getNetPrice(row){
                let that = this
                if(row.row.Currency_Unit == ''){
                    that.$message.warning(that.$t('getapi[3092]'))//货币不能为空
                    row.row.Price = ''
                    return
                }
                let parm = {
                    Currency_Unit: row.row.Currency_Unit,
                    Price: row.row.Price
                }
                that.$http.urlpost('/SalPriceAudit/GetNetPrice', parm , function (res) {
                    if (res.Success == 1) {
                        row.row.Net_Price = that.$processdata.mathRound4(res.Key)
                        row.row.base_net_price =''
                        row.row.base_price=''
                    }
                })
            },
            getPrice(row){
                let that = this
                if(row.row.Currency_Unit == ''){
                    that.$message.warning(that.$t('getapi[3092]'))//货币不能为空
                    row.row.Net_Price = ''
                    return
                }
                let parm = {
                    Currency_Unit: row.row.Currency_Unit,
                    Net_Price: row.row.Net_Price
                }
                that.$http.urlpost('/SalPriceAudit/GetPrice', parm , function (res) {
                    if (res.Success == 1) {
                        row.row.Price = that.$processdata.mathRound4(res.Key)
                        row.row.base_net_price =''
                        row.row.base_price=''
                    }
                })
            },
            getBasePrice(row){
                let that = this
                if(row.row.Currency_Unit == ''){
                    that.$message.warning(that.$t('getapi[3092]'))//货币不能为空
                    row.row.base_net_price = ''
                    return
                }
                let parm = {
                    Currency_Unit: row.row.Currency_Unit,
                    Base_Net_Price: row.row.base_net_price
                }
                that.$http.urlpost('/SalPriceAudit/GetBasePrice', parm , function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent[0]){
                            row.row.base_price = that.$processdata.mathRound4(res.DataContent[0].base_price)
                            row.row.Price = that.$processdata.mathRound4(res.DataContent[0].price)
                            row.row.Net_Price = that.$processdata.mathRound4(res.DataContent[0].net_price)
                        }
                    }
                })
            },
            getBaseNetPrice(row){
                let that = this
                if(row.row.Currency_Unit == ''){
                    that.$message.warning(that.$t('getapi[3092]'))//货币不能为空
                    row.row.base_price = ''
                    return
                }
                let parm = {
                    Currency_Unit: row.row.Currency_Unit,
                    Base_Price: row.row.base_price
                }
                that.$http.urlpost('/SalPriceAudit/GetBaseNetPrice', parm , function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent[0]){
                            row.row.base_net_price = that.$processdata.mathRound4(res.DataContent[0].base_net_price)
                            row.row.Price = that.$processdata.mathRound4(res.DataContent[0].price)
                            row.row.Net_Price = that.$processdata.mathRound4(res.DataContent[0].net_price)
                        }
                    }
                })
            },
            // 添加审核人
            selectemployee(type, row) {
                let that = this;
                that.employeeType = type;
                if (type == 1) {
                    that.selectIndexAudit = row.$index;
                    that.$refs.employee.clearInput(true, false, 2);
                } else if (type == 2) {
                    that.$refs.employee.clearInput(true, true, 2);
                }
            },
            //选择审核人
            getemployee(data){
                let that = this
                console.log(data);
                let datetime = Common.methods.getDatetime()
                let date = Common.methods.getDate()
                if(that.dataDetail.DTAuditInfo.length > 0){
                    data = data.filter(item => {
                        return that.dataDetail.DTAuditInfo.every(item2 => {
                            return item2.userID != item.code
                        })
                    })
                }
                if (that.employeeType == 1) {
                    that.dataDetail.DTAuditInfo[that.selectIndexAudit].Audit_Person = data[0].name
                    that.dataDetail.DTAuditInfo[that.selectIndexAudit].userID = data[0].code
                } else {
                    for (let i = 0; i < data.length; i++) {
                        let dataDetailLineNo = 0
                        for (let i = 0; i < that.dataDetail.DTAuditInfo.length; i++) {
                            if (that.dataDetail.DTAuditInfo[i].Sort >= dataDetailLineNo) {
                                dataDetailLineNo = parseInt(that.dataDetail.DTAuditInfo[i].Sort) + 1
                            }
                        }
                        that.dataDetail.DTAuditInfo = [
                            ...that.dataDetail.DTAuditInfo,
                            {
                                Exclusively_ID:'',
                                Relation_IID:'',
                                Sort:dataDetailLineNo++,
                                Audit_Person:data[i].name,
                                userID:data[i].code,
                                Audit_Status:0,
                                Audit_Date:'',
                                Audit_Msg:'',
                                superior_flag:1
                            }
                        ];
                    }
                }
            },
            checkDataChange(){
                let that = this
                //能打开此页面即拥有保存权限
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DTAuditInfo.length;i++){
                    delete datacopy.DTAuditInfo[i]['index']
                }
                for(let i = 0;i<datacopy.Sal_Price_Audit_LineList.length;i++){
                    delete datacopy.Sal_Price_Audit_LineList[i]['index']
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            },
            //判断字符是否为空
            fnIsEmpty(obj) {
                if (obj === null || obj === "") {
                    return true;
                }
                if (typeof(obj) === undefined || typeof(obj) == "undefined") {
                    return true;
                }
                return false;
            },
            //光标未离开禁用保存
            handleInputFocus(){
                let that = this
                that.$refs.SetBtn.SetOneBtnEnable('save',false);
            },
            handleInputBlur(){
                let that = this
                setTimeout(() => {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                }, 100);
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    /deep/.el-upload-list{
        display:none
    }
    /deep/ .gray {
        background: #cac6c6;
    }
    /deep/ .hidden {
        display: none;
    }
    /deep/ .red {
        background: #ff7879;
    }
    /deep/ .blue{
        background: #d2b32ce0;
    }
    .inline-container {
        display: flex;
        align-items: center;        /* 垂直居中对齐 */
        gap: 10px;                   /* 元素之间间距 */
    }
</style>
